let rectX = 50;
let rectY = 50;
let sceneWidth = 1920;
let sceneHeight = 1080;
let rectWidth = sceneWidth - 100;
let rectHeight = sceneHeight - 100;

const quizQuestions = [
    {
        question:
            'In the SGA process, which statement best describes a product classified with the "Anomaly" status?',
        answers: [
            {
                text: 'A product with no recorded sales in either the reference year or the current year.',
                isCorrect: false,
            },
            {
                text: 'A newly launched product with incomplete performance data.',
                isCorrect: false,
            },
            {
                text: 'A product with inconsistencies identified in sales or cost data base on automated process checks.',
                isCorrect: true,
            },
            {
                text: 'A discontinued product with no future sales forecast.',
                isCorrect: false,
            },
        ],
        debriefText:
            'In the context of the Sales Growth Analysis (SGA), the "Anomaly" status is assigned to products showing inconsistent data, either in terms of sales or costs of sales.\n\nThis classification is based on a series of automatic controls run at each SGA launch.',
        debriefScreenText: 'debriefText1',
        debriefScreenImage: 'debriefImage1',
        textPosition: [rectX + rectWidth / 2 - 160, rectY + 100],
        imagePosition: [rectX + rectWidth - 40, rectY + 100],
    },
    {
        question:
            'In SGA, which effects are analyzed only for “Existing” products to understand their impact on Net Sales?',
        answers: [
            {
                text: 'Total volume sold, contribution of new launches, and granted discounts.',
                isCorrect: false,
            },
            {
                text: 'List price changes, customer allowance variations, and clearances & returns.',
                isCorrect: true,
            },
            {
                text: 'Channel mix shifts, customer attrition rate, and organic growth.',
                isCorrect: false,
            },
            {
                text: 'Production cost, marketing investments, and acquisition strategy.',
                isCorrect: false,
            },
        ],
        debriefText:
            'In SGA, the List Price, Customer Allowances, and Clearances & Returns effects help assess how "Existing" products (whole data in both reference and analysis years) contributed to Net Sales evolution.',
        debriefScreenText: 'debriefText2',
        debriefScreenImage: 'debriefImage2',
        textPosition: [rectX + rectWidth - 178, rectY + 112],
        imagePosition: [rectX + rectWidth / 2 - 50, rectY + 50],
    },
    {
        question: 'Under what conditions can a Channel Mix effect be calculated in SGA?',
        answers: [
            {
                text: 'When channel sales are stable and volumes remain constant.',
                isCorrect: false,
            },
            {
                text: 'When P&L lines are split by channel and generic customer Net Sales fall within ±6K.',
                isCorrect: true,
            },
            {
                text: 'When comparing only new products sold through direct channels.',
                isCorrect: false,
            },
            {
                text: 'When gross margins are identical across all channels.',
                isCorrect: false,
            },
        ],
        debriefText:
            'The Channel Mix effect in SGA captures the revenue impact of changes in sales distribution across channels (direct, indirect, D2C, etc.)',
        debriefScreenText: 'debriefText3',
        debriefScreenImage: 'debriefImage3',
        textPosition: [rectX + rectWidth - 400, rectY + 100],
        imagePosition: [rectX + rectWidth - 400, rectY + rectHeight - 300],
    },
    {
        question:
            'Why does the Nominal List Price Increase calculation use invoiced units from “Existing” products as weighting?',
        answers: [
            {
                text: 'To reflect pricing changes across the entire product portfolio.',
                isCorrect: false,
            },
            {
                text: 'To isolate the effect from product and channel mix changes.',
                isCorrect: true,
            },
            {
                text: 'To include newly listed products in the analysis.',
                isCorrect: false,
            },
            {
                text: 'To automatically integrate promotion effects into the calculation.',
                isCorrect: false,
            },
        ],
        debriefText:
            'The Nominal List Price Increase aims to measure the official catalog list price change between two periods, independent of product effect and without Channel Mix (CT200001 - Total without Channel Mix in the Customer dimension), analyzed on YTD only.',
        debriefScreenText: 'debriefText4',
        debriefScreenImage: 'debriefImage4',
        textPosition: [rectX + rectWidth - 178, rectY + 300],
        imagePosition: [rectX + 600, rectY + 250],
    },
    {
        question:
            'Can an SGA analysis be performed using the “Flash Restated” scenario as the analysis scenario?',
        answers: [
            {
                text: 'Yes',
                isCorrect: false,
            },
            {
                text: 'No',
                isCorrect: true,
            },
        ],
        debriefText: 'The Flash Restated scenario in SGA cannot be used as an analysis scenario.',
        debriefScreenText: 'debriefText5',
        debriefScreenImage: 'debriefImage5',
        textPosition: [rectX + rectWidth - 178, rectY + 300],
        imagePosition: [rectX + 600, rectY + 250],
    },
    {
        question:
            'What happens if a controller modifies their Flash Restated scenario during the year in the official environment ?',
        answers: [
            {
                text: 'The tool keeps the original Flash to ensure historical consistency.',
                isCorrect: false,
            },
            {
                text: 'All previously calculated SGA indicators are frozen until year-end close.',
                isCorrect: false,
            },
            {
                text: 'An automatic SGA recalculation is triggered between the new Flash Restated and all impacted scenarios.',
                isCorrect: true,
            },
            {
                text: 'Mix and price effects are recalculated for new products only.',
                isCorrect: false,
            },
        ],
        debriefText:
            'If a controller modifies the Flash Restated this triggers an automatic relaunch of all SGA indicators tied to already officialized scenarios. This ensures comparability between the analysis year and updated reference data.',
        debriefScreenText: 'debriefText6',
        debriefScreenImage: 'debriefImage6',
        textPosition: [rectX + rectWidth - 178, rectY + 250],
        imagePosition: [rectX + 1000, rectY + 150],
    },
    {
        question:
            'In SGA, what does a positive product mix effect combined with a negative Volume effect indicate?',
        answers: [
            {
                text: 'That quantities sold increased but the product mix worsened.',
                isCorrect: false,
            },
            {
                text: 'That total sales volume dropped, but toward higher-value SKUs.',
                isCorrect: true,
            },
            {
                text: 'That the two effects cancel each other out in net sales.',
                isCorrect: false,
            },
            {
                text: 'That newly launched products were overrepresented in the mix.',
                isCorrect: false,
            },
        ],
        debriefText:
            'In SGA, the Volume effect measures changes in quantities sold at constant price, while the Mix effect captures shifts in product structure (e.g., more premium SKUs).',
        debriefScreenText: 'debriefText7',
        debriefScreenImage: 'debriefImage7',
        textPosition: [rectX + rectWidth - 100, rectY + 250],
        imagePosition: [rectX + 800, rectY + 150],
    },
];

export default quizQuestions;
